import { useState } from "react";
import { Bot, Check, CheckCircle, X } from "lucide-react";

const SPIN_STYLE = <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>;

const AI_FEATURES = [
  { icon: "🤖", label: "AI Lead Qualifier",     desc: "Auto-scores inbound leads"     },
  { icon: "📝", label: "Call Script Generator", desc: "Personalized per borrower"     },
  { icon: "📊", label: "Deal Analyzer",         desc: "Instant DSCR & LTV calc"      },
  { icon: "📅", label: "Follow-Up Scheduler",   desc: "Smart cadence automation"      },
];

/**
 * AISetupSection
 * Placeholder card for AI assistant deployment.
 * Mirrors the sales-manager AI setup flow with a Deploy → Loading → Deployed
 * state machine. Full integration is TBD — this is scaffolding only.
 */
export default function AISetupSection() {
  const [status, setStatus] = useState("idle"); // "idle" | "loading" | "deployed"

  function handleDeploy() {
    setStatus("loading");
    setTimeout(() => setStatus("deployed"), 2200);
  }

  return (
    <>
      {SPIN_STYLE}
      <div className="card" style={{ borderColor: "#e0e7ff", background: "linear-gradient(135deg, #f0f4ff 0%, #fafaff 100%)" }}>
        <div className="card-header" style={{ borderColor: "#e0e7ff", background: "transparent" }}>
          <span className="card-title" style={{ color: "#3730a3" }}>
            <Bot size={15} style={{ display: "inline", marginRight: 6, color: "#4f46e5" }} />
            AI Sales Assistant Setup
          </span>
          {status === "deployed" && (
            <span className="badge badge-green"><Check size={11} /> Deployed</span>
          )}
        </div>

        <div className="card-body">

          {status === "idle" && (
            <>
              <p style={{ fontSize: 13, color: "#4338ca", marginBottom: 18, lineHeight: 1.65 }}>
                Your personal AI sales assistant works the same way your manager's does — same model,
                same training data, deployed directly to your workflow. Click below to activate it for your account.
              </p>

              <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(180px, 1fr))", gap: 10, marginBottom: 20 }}>
                {AI_FEATURES.map(f => (
                  <div key={f.label} style={{ padding: "12px 14px", background: "#fff", border: "1px solid #e0e7ff", borderRadius: 10 }}>
                    <div style={{ fontSize: 20, marginBottom: 6 }}>{f.icon}</div>
                    <div style={{ fontSize: 12.5, fontWeight: 600, color: "#1e1b4b", marginBottom: 3 }}>{f.label}</div>
                    <div style={{ fontSize: 11.5, color: "#6366f1" }}>{f.desc}</div>
                  </div>
                ))}
              </div>

              <button
                className="btn btn-primary"
                onClick={handleDeploy}
                style={{ background: "#4f46e5", borderColor: "#4f46e5" }}
              >
                <Bot size={14} /> Deploy AI Assistant
              </button>

              <p style={{ fontSize: 11, color: "#6366f1", margin: "10px 0 0" }}>
                🔒 Placeholder — AI integration coming soon. Configuration will mirror the sales manager deployment.
              </p>
            </>
          )}

          {status === "loading" && (
            <div style={{ display: "flex", flexDirection: "column", alignItems: "center", padding: "28px 0", gap: 14 }}>
              <div style={{
                width: 44, height: 44, borderRadius: "50%",
                border: "3px solid #e0e7ff", borderTopColor: "#4f46e5",
                animation: "spin 0.8s linear infinite",
              }} />
              <p style={{ fontSize: 13, color: "#4338ca", fontWeight: 500 }}>Deploying your AI assistant…</p>
            </div>
          )}

          {status === "deployed" && (
            <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
              <div className="agent-banner" style={{ background: "#f0fdf4", border: "1px solid #bbf7d0", borderRadius: 10, padding: "14px 16px" }}>
                <CheckCircle size={18} color="#16a34a" style={{ flexShrink: 0 }} />
                <div className="agent-banner-text">
                  <strong style={{ color: "#166534" }}>AI Assistant Deployed</strong>
                  <span style={{ color: "#166534" }}>
                    Your assistant is active and monitoring your pipeline. (Placeholder — full integration TBD)
                  </span>
                </div>
              </div>
              <button
                className="btn btn-secondary btn-sm"
                style={{ alignSelf: "flex-start" }}
                onClick={() => setStatus("idle")}
              >
                <X size={12} /> Reset (test only)
              </button>
            </div>
          )}

        </div>
      </div>
    </>
  );
}